'use strict';

var account = require('site/pages/account'),
	bonusProductsView = require('site/bonus-products-view'),
	dialog = require('site/dialog'),
	quickview = require('site/quickview'),
	cartStoreInventory = require('site/storeinventory/cart'),
	quantity = require('site/pages/product/quantity'),
	linchpin = require('int_googletagmanager/linchpin/cart'),
	subscriptions = require('int_googletagmanager/linchpin/subscription'),
	checkout = require('int_googletagmanager/linchpin/orderreview'),
	ordergroove = require('int_ordergroove/ordergroove/cart');

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
	$('#cart-table').on('click', '.item-edit-details a', function (e) {
		e.preventDefault();
		quickview.show({
			url: e.target.href,
			source: 'cart'
		});
	})
	.on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
		e.preventDefault();
		bonusProductsView.show(this.href);
	});

	$('button.remove.commited-subscription-child').on('click', function (e) {
		e.preventDefault();
		var $button = $(this);
		var $cartRow = $button.parents('.cart-row');
		var productQuantity = $cartRow.find('.li-qty span').text() + ' x ';
		var productName = $cartRow.find('.name a').text();
		var productParentInfo = $cartRow.find('.parent-product-name').text() + ' - ' + $cartRow.find('.parent-product-price').text();
		var html = $('#cart-items-form').find('.remove-child-dialog-html').first().clone();

		html.find('.remove-product-qty').text(productQuantity);
		html.find('.remove-product-name').text(productName);
		html.find('.remove-product-parent-info').text(productParentInfo);
		dialog.open({
			html: html,
			options: {
				dialogClass: 'cart-dialog',
				open: function () {},
				buttons: [
					{
						text: Resources.OG_MaR_REMOVE_BUTTON,
						class: 'btn',
						click: function () {
							$button.off('click');
							$button.trigger('click');
						}
					},
					{
						text: Resources.OG_CANCEL_TITLE,
						class: 'btn-close',
						click: function () {
							dialog.close();
						}
					}
				],
				title: Resources.REMOVE
			}
		});
	});

	// override enter key for coupon code entry
	$('form input[name$="_couponCode"]').on('keydown', function (e) {
		if (e.which === 13 && $(this).val().length === 0) {
			$('.coupon-error').html(Resources.COUPON_CODE_MISSING);
			return false;
		}
	});

	$('#add-coupon').on('click', function (e) {
		var $field = $('input[name$="_couponCode"]');
		if ($field.val().length === 0) {
			e.preventDefault();
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.promoCodeAttemptEvent();
				linchpin.promoCodeFailureEvent();
			}
			$('.coupon-error').html(Resources.COUPON_CODE_MISSING);
		}
	});

	$('.continue-shopping a').on('click', function (e) {
		e.preventDefault();
		var options = {
				url: Urls.checkProductCartEligibility
			},
			linkUrl = $(this).attr('href');
		$.ajax(options).done(function (data) {
			if (data.success === false && data.error === 'TC_DEBT') {
				dialog.open({
					url: Urls.tcSettleBalanceError,
					options: {
						buttons: [
							{
								text: Resources.CANCEL,
								'class':'button-gray',
								click: function () {
									$(this).dialog('close');
								}
							},
							{
								text: Resources.SETTLE_BALANCE,
								click: function () {
									window.location = Urls.shippingStart;
								}
							}
						],
						title: Resources.SORRY
					}
				});
			} else {
				window.location = linkUrl;
			}
		});
	});
	// prevent minicart from being opened on the cart page
	$('#mini-cart').unbind('touchstart mouseenter');

	$('.item-user-actions .remove').on('click', function (e) {
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.removeFromBag(e);
			linchpin.updateProductInBag(e);
		}
	});

	$('.update-qty').on('click', function (e) {
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.updateProductInBag(e);
		}
	});

	$('button[name$="_cart_clearBag"]').on('click', function (e) {
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.clearBag(e);
		}
	});

	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		checkout.orderReviewEvent();
	}
	$('.item-list').on('click', '.delivery-info-title .view', function () {
		$(this).parent().siblings('.delivery-block').slideDown();
		$(this).hide().siblings().show();
	});
	$('.item-list').on('click', '.delivery-info-title .hide', function () {
		$(this).parent().siblings('.delivery-block').slideUp();
		$(this).hide().siblings().show();
	});

	$('.cart-coupon-code .toggle-title').on('click', function (e) {
		e.preventDefault();
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.promoCodeClickEvent();
		}
	});

	if ($('.coupon-error').text().trim() !== '' || $('.applied-coupon-code').length) {
		$('.cart-coupon-code.toggle-information .toggle-title').trigger('click');
	}

	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		$('button[name$="cart_checkoutCart"]').on('click', function () {
			linchpin.trackCheckoutStartClick('Checkout Securely');
		});
		$('.amazon-container').on('click', function () {
			linchpin.trackCheckoutStartClick('Amazon Pay');
		});
	}
}

/**
 * @function
 * @description Toggling components of Build a box bundle
 */
 function toggleBaBComponents() {
	$('.box-components').on('click', '.box-components-title span', function () {
		$(this).hide().siblings().show();
		$(this).closest('.box-components-title').siblings('.box-components-block').toggle();
		$(this).closest('.iscroll-wrapper').trigger('refresh');
	});
}

exports.toggleBaBComponents = toggleBaBComponents;

exports.init = function () {
	initializeEvents();
	quantity.init();
	ordergroove.init();
	if (SitePreferences.STORE_PICKUP) {
		cartStoreInventory.init();
	}
	account.initCartLogin();
	toggleBaBComponents();
	if (SitePreferences.GTM_ENABLED) {
		setTimeout(subscriptions.getSubscriptionAddToBagData, 3000);
		linchpin.addConfiguratorAddToBagEvents();
	}
};
